import { ModuleSectionItem } from "./module-section-item";

export class ModuleItem {
    ModuleId: number;
    CourseId: number;
    Title: string;
    Ordinal: number;
    AssignmentStatus: number;
    Sections: Array<ModuleSectionItem>;
    
    constructor(init?: Partial<ModuleItem>) {
        Object.assign(this, init);
    }
}